<template>
  <div class="container">
    <div class="detail-crumbs">
      <template v-for="(item, index) in crumbs" :key="index">
        <template v-if="item && item.url">
          <router-link :to="item.url">{{ item.title }}</router-link> >
        </template>
        <span v-else>{{ item && item.title }}</span>
      </template>
    </div>
    <h1 class="detail-title">{{ detailData.title }}</h1>
    <p class="detail-source">
      来源: {{ detailData.source }}
      <!-- &nbsp;&nbsp;&nbsp;&nbsp;创建时间:{{moment(detailData.created_time).format('YYYY/MM/DD hh:ss:mm')
      }} -->
    </p>
    <div class="detail-content" v-html="detailData.content"></div>
  </div>
</template>
<script>
// import moment from 'moment';
import { reactive } from 'vue';
import { reportinfo } from './helper/api';
import { urlUtil } from '@/utils';
export default {
  name: 'Detail',
  components: {},
  setup() {
    const detailData = reactive({});
    const types = [
      { type: '1', title: '典型案例', url: '/newslist?type=1' },
      { type: '2', title: '法律法规', url: '/newslist?type=2' },
      { type: '3', title: '预警提示', url: '/newslist?type=3' },
      { type: '4', title: '历史记忆', url: '/newslist?type=4' },
      { type: '5', title: '党建园地', url: '/newslist?type=5' }
    ];
    const { type = 1 } = urlUtil.parseQuery();
    const crumbs = reactive([{ title: '首页', url: '/' }]);
    // crumbs.push(types[parseInt(type) - 1]);
    crumbs.push(types.find(item => item.type === type));
    const { id } = urlUtil.parseQuery();
    reportinfo(id).then(res => {
      Object.assign(detailData, res);
      crumbs.push({
        title: detailData.title
      });
    });

    return {
      detailData,
      crumbs
      // moment
    };
  }
};
</script>

<style lang="scss">
@import './style/config';
.detail {
  &-title {
    color: #222;
    font-size: 48px;
    text-align: center;
  }
  &-source {
    font-size: 24px;
    height: 30px;
    line-height: 30px;
    text-align: center;
    color: #999;
    overflow: hidden;
  }
  &-content {
    margin: 40px;
    font-size: 28px;
    text-indent: 2em;
    min-height: 400px;
    line-height: 1.5;
    // display: flex;
    p {
      margin: 1em 0;
    }
    * {
      max-width: 100%;
    }
    iframe {
      width: 100%;
      height: 100%;
      display: block;
    }
  }
  &-crumbs {
    margin: 40px;
    font-size: 20px;
    color: #ccc;
    overflow: hidden;
    a {
      color: #666;
    }
    span {
      color: $primary;
    }
  }
}
</style>
